// First Preact + JSX component — replaces stats/index.ts statCard().
//
// 이 컴포넌트가 Week 2 마이그레이션의 기준점. 스타일·DOM 구조는 기존
// statCard()와 100% 동일하게 유지하되 작성 방식만 JSX로 전환.

interface StatCardProps {
  label: string;
  value: number | string | null | undefined;
}

export function StatCard({ label, value }: StatCardProps) {
  return (
    <div class="stat-card">
      <div class="stat-card__value">{String(value ?? 0)}</div>
      <div class="stat-card__label">{label}</div>
    </div>
  );
}
